import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import '../Components/Styles/articles.css';

function CategorieProducts() {
  const { categoryName } = useParams();
  const isPack = categoryName === 'nos-packs';
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeFilter, setActiveFilter] = useState('tous');
  const [promos, setPromos] = useState([]);

  const [filters, setFilters] = useState([]);
  const [isBrand, setIsBrand] = useState(false);

  useEffect(() => {
    fetch(`/api/brands.php?action=filters&brand=${categoryName}`)
      .then(res => res.json())
      .then(data => {
        if (data.length > 0) {
          setFilters(data);
          setIsBrand(true);
        } else {
          setFilters([]);
          setIsBrand(false);
        }
      })
      .catch(() => setIsBrand(false));
  }, [categoryName]);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setActiveFilter('tous');
    fetch(`/api/categoriesProducts.php?categorie=${categoryName}`)
      .then(res => {
        if (!res.ok) throw new Error('Erreur lors de la récupération des produits');
        return res.json();
      })
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [categoryName]);

  const categoryLabels = {
  // Produits -> Alimentation Saine
  "barres-snacks": "Barres et Snacks",
  "boissons": "Boissons",
  "petit-dejeuner": "Petit Déjeuner",
  "farines-cereales": "Farines, Céréales",
  "dejeuner-diner": "Déjeuner et Dîner",
  "sauces-sirops-confitures": "Sauces, Sirops, Confitures",
  "beurre-de-cacahuete": "Beurre de cacahuète",
  "pate-a-tartiner": "Pâte à tartiner",

  // Produits -> Nutrition
  "proteines": "Protéines",
  "developpement-musculaire": "Développement musculaire",
  "energie-endurance": "Énergie et Endurance",
  "bruleur-de-graisse": "Brûleur de Graisse",
  "recuperation": "Récupération",
  "pre-workout": "Pré-workout",

  // Produits -> Santé et Minceur
  "perte-de-poids": "Perte de Poids",
  "sante": "Santé",
  "vitamines-mineraux-herbes": "Vitamines, Minéraux, Herbes",

  // Produits -> Packs
  "nos-packs": "Nos Packs",

  // Equipements -> Fitness
  "manique": "Manique",
  "corde-a-sauter": "Corde à sauter",
  "genouillere": "Genouillère",
  "poignet-de-force": "Poignet de force / Sangle de tirage",
  "shaker": "Shaker",

  // Equipements -> Rugby
  "protege-dents": "Protège dents",
  "rasage": "Pour le rasage",
  "casque": "Casque",

  // Vêtements -> Fitness
  "fitness-maillot": "Maillot",
  "fitness-pull-veste": "Pull / Veste",
  "fitness-short": "Short",
  "fitness-jogging": "Jogging",
  "fitness-chaussettes": "Chaussettes",
  "fitness-chaussures": "Chaussures",

  // Vêtements -> Rugby
  "rugby-maillot": "Maillot",
  "rugby-pull-veste": "Pull / Veste",
  "rugby-short": "Short",
  "rugby-jogging": "Jogging",
  "rugby-chaussettes": "Chaussettes",
  "rugby-crampons": "Crampons",
  "rugby-ensemble": "Ensemble",

  // Nos marques
  "nutripure": "Notre gamme Nutripure",
  "biotech": "Notre gamme Biotech",

  // Promo
  "promo": "Promotions"
};

const filteredProducts = isBrand && activeFilter !== 'tous'
  ? products.filter(p => p.categorie.includes(activeFilter))
  : products;

  if (loading) return <p>Chargement des produits...</p>;
  if (error) return <p>Erreur : {error}</p>;
  if (products.length === 0) return <h2 className='no-products'>Aucun produit dans cette catégorie pour le moment</h2>;


  return (
    <div className="allproducts-categories">
      <h1 className='categories-title'>{categoryLabels[categoryName] || categoryName}</h1>
      <div className="products-container">
        {isBrand && (
          <aside className="brand-sidebar">
            <h2>Filtrer par</h2>
            {filters.map(f => (
              <button
                key={f.key}
                className={`sidebar-item ${activeFilter === f.key ? 'active' : ''}`}
                onClick={() => setActiveFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </aside>
        )}
        <div className="ap-container">
          {filteredProducts.map(item => {
            if (isPack) {
              return (
                <div key={item.id} className="product-card">
                  <Link to={`/pack/${item.id}`}>
                    <img
                      src={`/static/media/${item.image}`}
                      alt={item.nom}
                      width={250}
                    />
                    <div className="infos-desc-produits">
                      <h3>{item.nom}</h3>
                      <p>{Number(item.prix).toFixed(2)} €</p>
                    </div>
                  </Link>
                </div>
              );
            }

            const defaultVarianteOptionId = item.variante_option_id;
            const promo = promos.find(p => p.variante_option_id === defaultVarianteOptionId);
            const prixPromo = promo
              ? promo.type_reduction === 'pourcentage'
                ? (promo.prix_normal * (1 - promo.valeur / 100)).toFixed(2)
                : (promo.prix_normal - promo.valeur).toFixed(2)
              : null;
          
            return (
              <div key={item.id} className="product-card">
                <Link to={`/produit/${item.id}`}>
                  <div style={{ position: 'relative' }}>
                    <img src={`/static/media/${item.image}`} alt={item.nom} width={250} />
                    {item.prix_promo && (
                      <span className="promo-badge">
                        {item.type_reduction === 'pourcentage'
                          ? `-${Math.round(item.promo_valeur)}%`
                          : `-${item.promo_valeur % 1 === 0 ? item.promo_valeur : Number(item.promo_valeur).toFixed(2)}€`}
                      </span>
                    )}
                  </div>
                  <div className="infos-desc-produits">
                    <h3>{item.nom}</h3>
                    <p>
                      {item.prix_promo
                        ? `${Number(item.prix_promo).toFixed(2)} € `
                        : `${Number(item.default_prix).toFixed(2)} €`}
                      {item.prix_promo && (
                        <span style={{ textDecoration: 'line-through', color: '#999', marginLeft: '8px' }}>
                          {Number(item.prix_normal).toFixed(2)} €
                        </span>
                      )}
                    </p>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CategorieProducts;